import { render, staticRenderFns } from "./ModalCadastrar.vue?vue&type=template&id=3d8131f2"
import script from "./ModalCadastrar.vue?vue&type=script&lang=js"
export * from "./ModalCadastrar.vue?vue&type=script&lang=js"
import style0 from "./ModalCadastrar.vue?vue&type=style&index=0&id=3d8131f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports